import { atTimeOfEvent } from '../strings.locstring.json';
import { noReminder } from 'owa-locstrings/lib/strings/noreminder.locstring.json';
import loc from 'owa-localize';

import ReminderOptionType from '../helpers/ReminderOptionType';
import getNonAllDayReminderString from './getNonAllDayReminderString';
import { DefaultReminderOffsets } from './emailReminderConsts';

export default function getNonAllDayReminderOption(
    includeNoReminder: boolean
): ReminderOptionType[] {
    const {
        NO_REMINDER,
        AT_TIME_OF_EVENT,
        MINUTES_BEFORE_5,
        MINUTES_BEFORE_15,
        MINUTES_BEFORE_30,
        HOURS_BEFORE_1,
        HOURS_BEFORE_2,
        HOURS_BEFORE_12,
        DAYS_BEFORE_1,
        DAYS_BEFORE_7,
    } = DefaultReminderOffsets;

    return ([
        // No ReminderOptionType
        includeNoReminder ? { key: NO_REMINDER, text: loc(noReminder) } : null,
        // At time of event.
        { key: AT_TIME_OF_EVENT, text: loc(atTimeOfEvent) },
        // 5 minutes before
        { key: MINUTES_BEFORE_5, text: getNonAllDayReminderString(5) },
        // 15 minutes before
        { key: MINUTES_BEFORE_15, text: getNonAllDayReminderString(15) },
        // 30 minutes before
        { key: MINUTES_BEFORE_30, text: getNonAllDayReminderString(30) },
        // 1 hour before
        { key: HOURS_BEFORE_1, text: getNonAllDayReminderString(60) },
        // 2 hours before
        { key: HOURS_BEFORE_2, text: getNonAllDayReminderString(60 * 2) },
        // 12 hours before
        { key: HOURS_BEFORE_12, text: getNonAllDayReminderString(60 * 12) },
        // 1 day before
        { key: DAYS_BEFORE_1, text: getNonAllDayReminderString(60 * 24) },
        // 1 week before
        { key: DAYS_BEFORE_7, text: getNonAllDayReminderString(60 * 24 * 7) },
    ] as ReminderOptionType[]).filter(option => !!option);
}
